import { PlayerWithPAMDetails } from '@Generated/back-office-client/src'
import { Card, Flex, Text } from '@radix-ui/themes'
import { useLocation, useOutletContext, useParams } from 'react-router-dom'

export const PlayerDetails = () => {
  const location = useLocation()
  const params = useParams()
  const outletContext = useOutletContext<PlayerWithPAMDetails | null>()

  const playerLookupId = params?.lookupId
  const playerDetails = playerLookupId
    ? ((location.state as PlayerWithPAMDetails) ?? outletContext)
    : null

  if (!playerDetails) {
    return null
  }

  return (
    <Card className="player-external-details">
      <Flex direction="column" gap="6" className="player-result-row">
        <Flex gap="9">
          <Flex direction="column" gap="9">
            <Flex direction="column">
              <Text weight="bold">Name</Text>
              <Text>{playerDetails.details.name ?? 'N/A'}</Text>
            </Flex>

            <Flex direction="column">
              <Text weight="bold">Address</Text>
              <Text>{playerDetails.details.address ?? 'N/A'}</Text>
            </Flex>
          </Flex>

          <Flex direction="column" gap="9">
            <Flex direction="column">
              <Text weight="bold">Email</Text>
              <Text>{playerDetails.details.email ?? 'N/A'}</Text>
            </Flex>

            <Flex direction="column" justify="end">
              <Text weight="bold">City</Text>
              <Text>{playerDetails.details.city ?? 'N/A'}</Text>
            </Flex>
          </Flex>

          <Flex direction="column" gap="9">
            <Flex direction="column">
              <Text weight="bold">Phone</Text>
              <Text>{playerDetails.details.phone ?? 'N/A'}</Text>
            </Flex>

            <Flex direction="column" justify="end">
              <Text weight="bold">State</Text>
              <Text>{playerDetails.details.region ?? 'N/A'}</Text>
            </Flex>
          </Flex>

          <Flex direction="column" justify="end">
            <Text weight="bold">Zip</Text>
            <Text>{playerDetails.details.postalCode ?? 'N/A'}</Text>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  )
}
